import React, { FC } from 'react';
import EXTENSIONS_ICONS from 'components/Icons/ExtensionsIcons';

interface LinkPreviewProps {
  link: string;
}

const LinkPreview: FC<LinkPreviewProps> = ({ link }) => {
  const href = link.indexOf('http://') === 0 || link.indexOf('https://') === 0 ? link : `http://${link}`;

  return (
    <a className="button-clear" href={href} target="_blank" rel="noreferrer" onClick={ev => ev.stopPropagation()}>
      <img src={EXTENSIONS_ICONS['link']} alt="link" />
      {link}
    </a>
  );
};

export default LinkPreview;
